import { useConfigStore } from "@/stores/config"
import axios from "axios"
import api from "@/api/viktor"

// USED IN DEV MODE ONLY
export async function login(options: { email: string }) {
  const configStore = useConfigStore()
  const { urls, oauth_token } = configStore
  const { email } = options

  return axios
    .post(`${urls.api}/auth/oauth`, {
      email,
      token: oauth_token,
    })
    .then((response) => response.data)
    .catch((err) => console.warn(err))
}

export async function refreshToken(token: string) {
  const response = await api({
    method: "POST",
    url: "/auth/refresh",
    data: {
      refresh_token: token,
    },
  })
  return response
}
